"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeakoUserAgentVersion = exports.DeakoRequestDevice = exports.AppCode = exports.ReleaseChannel = void 0;
var ReleaseChannel;
(function (ReleaseChannel) {
    ReleaseChannel["PROD_ANDROID"] = "GooglePlayStore";
    ReleaseChannel["PROD_IOS"] = "AppleAppStore";
    ReleaseChannel["INTERNAL"] = "Internal";
    ReleaseChannel["DOGFOOD"] = "CrashlyticsBetaDogfood";
    ReleaseChannel["DEV"] = "Unreleased";
})(ReleaseChannel = exports.ReleaseChannel || (exports.ReleaseChannel = {}));
var AppCode;
(function (AppCode) {
    AppCode["MOBILE"] = "DeakoApp";
    AppCode["CS_TOOL"] = "CSTool";
    AppCode["NODE"] = "Node";
})(AppCode = exports.AppCode || (exports.AppCode = {}));
var DeakoRequestDevice;
(function (DeakoRequestDevice) {
    DeakoRequestDevice["V1"] = "Deako-Device-V1";
})(DeakoRequestDevice = exports.DeakoRequestDevice || (exports.DeakoRequestDevice = {}));
var DeakoUserAgentVersion;
(function (DeakoUserAgentVersion) {
    DeakoUserAgentVersion[DeakoUserAgentVersion["DONTUSE"] = 0] = "DONTUSE";
    DeakoUserAgentVersion[DeakoUserAgentVersion["VERSION_1"] = 1] = "VERSION_1";
})(DeakoUserAgentVersion = exports.DeakoUserAgentVersion || (exports.DeakoUserAgentVersion = {}));
//# sourceMappingURL=Types.js.map